import { render, staticRenderFns } from "./IconFilePdf.vue?vue&type=template&id=617b14c1&"
import script from "./IconFilePdf.vue?vue&type=script&lang=js&"
export * from "./IconFilePdf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports